import type { ReactNode } from 'react';

import { SidebarFooter } from '@/components/ui/sidebar-sections';

export function SidebarFooterSlot({ children }: Readonly<{ children?: ReactNode }>) {
  if (!children) return null;
  return <SidebarFooter>{children}</SidebarFooter>;
}
